// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const File: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="m18.707 7.293-5-5A.997.997 0 0 0 13 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8a.997.997 0 0 0-.293-.707ZM14 5.414 15.586 7H14V5.414ZM7 20V4h5v4a1 1 0 0 0 1 1h4v11H7Z" />
    <path d="M14 11h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Zm0 4h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Z" />
  </SvgIcon>
);

File.activeColor = '#0047FF';
File.muiName = 'File';
